import React, { useCallback, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { setStep } from "../redux/formDataSlice";
import CustomStepper from "../../../components/common/CustomStepper";
import { Description, Title } from "../Wallet/ChinaPayoutV2/styles";
import { Wrapper } from "./styles";
import { PaymentStep, paymentStepsByCurrency } from "../const";

const PayoutV2 = () => {
  const dispatch = useAppDispatch();
  const step = useAppSelector((state) => state.formData.step);
  const { currencyCode } = useParams<{ currencyCode: string }>();

  const steps: PaymentStep[] = useMemo(() => {
    const code = (currencyCode);
    return paymentStepsByCurrency[code] ?? paymentStepsByCurrency.ghs;
  }, [currencyCode]);


  const stepItems = useMemo(
    () =>
      steps.map((s, idx) => ({
        title: s.title,
        description: s.description,
        stepTitle: s.stepTitle,
        stage: idx,
      })),
    [steps],
  );

  const handleChangeStep = useCallback(
    (newIndex: number) => {
      if (newIndex >= 0 && newIndex < steps.length) {
        dispatch(setStep(newIndex));
      }
    },
    [dispatch, steps.length],
  );

  const renderStepContent = useCallback(() => {
    const StepComp = steps[step]?.component;
    return StepComp ? (
      <StepComp
        handleNext={() => handleChangeStep(step + 1)}
        handlePrevious={() => handleChangeStep(step - 1)}
      />
    ) : null;
  }, [steps, step, handleChangeStep]);

  return (
    <Wrapper>
      <CustomStepper stages={stepItems} step={step} setStep={setStep} />
      <Title>{stepItems[step]?.stepTitle}</Title>
      <Description>{stepItems[step]?.description}</Description>
      {renderStepContent()}
    </Wrapper>
  );
};

export default PayoutV2;
